<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('用户主键')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userKeyId']" :placeholder="$t('请输入用户主键')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('用户编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['userId']" :placeholder="$t('请输入用户编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('表编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['meterId']" :placeholder="$t('请输入表编号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('消息标记：1，剩余金额告警信息')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['messageFlag']" :placeholder="$t('请输入消息标记：1，剩余金额告警信息')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送信息内容')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['message']" :placeholder="$t('请输入发送信息内容')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送方式 1短信 2微信')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['sendWay']" :placeholder="$t('请输入发送方式 1短信 2微信')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送标记 1定时发送 2手动发送')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sendFlag']" :placeholder="$t('请输入发送标记 1定时发送 2手动发送')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送的微信Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['openId']" :placeholder="$t('请输入发送的微信Id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送的电话号码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phone']" :placeholder="$t('请输入发送的电话号码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送成功标记 0失败 1成功')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['successFlag']" :placeholder="$t('请输入发送成功标记 0失败 1成功')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('发送重试次数')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['retryTime']" :placeholder="$t('请输入发送重试次数')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="remark" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remark']" :placeholder="$t('请输入remark')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('所属部门Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sysOrgCode']" :placeholder="$t('请输入所属部门Id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('创建时间')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择创建时间')" v-decorator="['createTime', validatorRules.createTime]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('创建操作员代码')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createBy']" :placeholder="$t('请输入创建操作员代码')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('修改时间')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('请选择修改时间')" v-decorator="['updateTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('修改操作员Id')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['updateBy']" :placeholder="$t('请输入修改操作员Id')"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{ $t('提 交') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'MeterMessageRecordForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterMessageRecord/add",
          edit: "/jeecg-charge/meter/meterMessageRecord/edit",
          queryById: "/jeecg-charge/meter/meterMessageRecord/queryById"
        }
      }
    },
    computed: {
      validatorRules() {
        return {
          createTime: {
            rules: [
              { required: true, message: this.$t('请输入创建时间!')},
            ]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userKeyId','userId','meterId','messageFlag','message','sendWay','sendFlag','openId','phone','successFlag','retryTime','remark','sysOrgCode','createTime','createBy','updateTime','updateBy'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'userKeyId','userId','meterId','messageFlag','message','sendWay','sendFlag','openId','phone','successFlag','retryTime','remark','sysOrgCode','createTime','createBy','updateTime','updateBy'))
      },
    }
  }
</script>